import { PrismicLinkContext } from '@monofront/types';
import React, { PropsWithChildren, useContext } from 'react';
import invariant from 'tiny-invariant';

const LinkingContextContext = React.createContext<PrismicLinkContext | null>(
  null,
);

export const LinkingContextProvider = ({
  linkingContext,
  children,
}: PropsWithChildren<{
  linkingContext: PrismicLinkContext;
}>) => {
  return (
    <LinkingContextContext.Provider value={linkingContext}>
      {children}
    </LinkingContextContext.Provider>
  );
};

export const useLinkingContext = () => {
  const ctx = useContext(LinkingContextContext);

  invariant(ctx, 'A LinkingContextProvider must be present');

  return ctx;
};
